<template>
<div>
  <div v-if="loaded" id="liveBJY" :class="{fullscreen: isFull}">
      <LiveStatus
        v-show="!playing"
        @clickPlayer="clickPlayer"
        :loading="loading"
        :liveStatus="liveStatus"
        :onLine="onLine"
        :isFull="isFull"
        @operation="operation"

      />
      <Control
        v-show="playing && controlShow"
        :isFull="isFull"
        :onlyPlayer="onlyPlayer"
        @operation="operation"
      />
      <div :class="['video-wrap',{fullVideoWrap:onlyPlayer}]" @click="controlShow = true;">
          <Player ref="player" v-if="templateType === 3"/>
          <WhiteBoard ref="whiteboard" v-else  />
      </div>
      <TeacherList
        v-show="isTeacherShow() && !onlyPlayer"
        :RecommendCourse="RecommendCourse"
      />
      <div
        v-if="templateType !== 3"
        v-show="playing && (isCamera || isCameraImg) && !onlyPlayer"
        ref="other-video-wrap"
        :class="['other-video-wrap', {noAdvertisement:!RecommendCourse.imagesH5,fullOtherVideo:isFull}]"
        @touchstart="touchstartHandle('other-video-wrap',$event)"
        @touchmove="touchmoveHandle('other-video-wrap',$event)"
      >
        <Player ref="player"/>
      </div>
      <div v-show="!onlyPlayer" :class="['media-panel',isTeacherShow() ? 'media-panel-teacher' : 'media-panel-player']">
        <InteractionPanel :RecommendCourse="RecommendCourse" :isFull="isFull" @destroyLiveRoom="destroyLiveRoom"/>
      </div>
      <HotRecommend v-if="hotRecommendShow" @closeHotPopup="hotRecommendShow = false"/>
      <OpenApp v-if="!isFull" />
    </div>
    <!-- <AgreementPop v-show="loaded" :openCourseId="buyRecord"/> -->
    <EntranceTest v-if="buyInfo.id" :id="buyInfo.id"/>

    <CommonLoading v-if="!loaded" />
</div>
</template>
<script>
import moment from 'moment';
import { mapState } from 'vuex';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';
import Player from './components/player.vue';
import LiveStatus from './components/liveStatus.vue';
import Control from './components/control.vue';
import TeacherList from './components/teacherList.vue';
import WhiteBoard from './components/whiteBoard.vue';
import HotRecommend from './components/hotRecommend.vue';
import InteractionPanel from './components/interactionPanel.vue';
import OpenApp from '../live/components/openApp.vue';
// import AgreementPop from '../live/components/agreementPop.vue';
import EntranceTest from '../live/components/entranceTest.vue';

import { getLiveBJY } from '../../api/liveBJY/index';
import { reqIsBuyProduct } from '../../api/courseDetail/index';
import { reqliveDetails, sendUploadStudyProgress } from '../../api/live/index';

// eslint-disable-next-line no-undef
const { eventEmitter, store } = BJY;
export default {
  components: {
    Player,
    InteractionPanel,
    WhiteBoard,
    LiveStatus,
    Control,
    CommonLoading,
    OpenApp,
    TeacherList,
    HotRecommend,
    // AgreementPop,
    EntranceTest,
  },
  data() {
    return {
      courseId: this.$route.query.courseId,
      roomId: this.$route.query.roomId,
      templateType: Number(this.$route.query.templateType || 3), // 3 大视频 4 三分屏
      liveId: this.$route.query.liveId, // 用于查询推荐课程
      chapterId: this.$route.query.chapterId,
      buyRecord: null,

      userData: {}, // 直播签名信息
      loaded: false,
      namespace: `.live${Math.random()}`,
      coordinate: { // 坐标
        client: {},
        elePosition: {},
      },
      playing: false, // 是否已经点击播放
      liveStatus: '', // 0 未开始 1 已开始 2 已结束 3断网
      loading: false, // 视频加载loading
      controlShow: false, // 控制条的显隐
      RecommendCourse: {}, // 推荐数据
      isFull: false, // 是否全屏
      onLine: true, // true 连网 false 断网
      onLineTimer: null, // 查询网络状态倒计时
      isCamera: true, // 老师是否开启摄像头
      isCameraImg: false, // 是否有摄像头占位图
      teacherShow: false, // 教师姓名是否展示
      onlyPlayer: false, // 只展示全屏视频
      hotRecommendShow: false, // 热门推荐显隐
      // 上报相关
      studyStartTime: 0, // 学习开始
      studyTime: 0, // 学习时长
      liveStudyTimer: null, // 学习时长定时器
      reportTime: 0, // 本次上报时间
      lastReportTime: 0, // 上次上报时间
      isLiveStart: false,
      firstReport: false,
    };
  },
  watch: {
    controlShow(value) {
      if (value) {
        if (this.setTimer) clearTimeout(this.setTimer);
        this.setTimer = setTimeout(() => {
          this.controlShow = false;
        }, 8000);
      }
    },
    isFull(value) {
      setTimeout(() => {
      // 通知白板更新宽高
        eventEmitter.trigger(
          eventEmitter.WINDOW_RESIZE,
        );
      });
      if (value) {
        this.fullScreen();
        return;
      }
      this.onlyPlayer = false;
      this.exitFullScreen();
    },
    onlyPlayer() {
      setTimeout(() => {
      // 通知白板更新宽高
        eventEmitter.trigger(
          eventEmitter.WINDOW_RESIZE,
        );
      });
    },
  },
  computed: {
    ...mapState(['userInfo']),
  },
  async created() {
    this.getBuyInfo();
    this.getCourseIds();
  },
  methods: {
    // 查询开课信息(是否购买)
    async getBuyInfo() {
      const res = await reqIsBuyProduct(this.courseId);
      if (res?.code === 0 && res?.data?.length) {
        // 已购买
        this.buyInfo = res?.data?.[0];
        this.buyRecord = this.buyInfo.id;
        this.getLiveBJYData();
      } else {
        // 未购买
        this.jumpCourseDetail();
      }
    },
    async getLiveBJYData() {
      const res = await getLiveBJY({
        roomId: this.roomId,
        userProductId: this.buyInfo.id,
      });
      if (res.code === 0) {
        this.userData = res?.data;
        this.createLive();
      } else {
        this.$toast('获取签名失败，请刷新重试');
      }
    },
    createLive() {
      const {
        roomId, userAvatar, userName, userRole, sign, userId,
      } = this.userData;
      const options = {
        prefixName: 'e62593546',
        env: 'production',
        room_id: roomId,
        user_number: userId,
        user_avatar: userAvatar,
        user_name: userName,
        user_role: userRole,
        sign,
        webrtc: 0,
      };
      const classOption = {
      // 必须为字符串
        id: options.room_id,
      };
      // eslint-disable-next-line no-undef
      BJY.init({
        env: options.env,
        privateDomainPrefix: options.prefixName,
        class: classOption,
        user: {
          number: options.user_number,
          avatar: decodeURIComponent(options.user_avatar),
          name: decodeURIComponent(options.user_name),
          type: Number(options.user_role),
        },
        teacher: {
          type: 1,
        },
        sign: options.sign,
      }).then(() => {
        // const TEMPLATE_PPT_AS_MAIN = 1;
        // eslint-disable-next-line no-undef
        // this.isPptAsMain = BJY.store.get('partner.mTemplate') === TEMPLATE_PPT_AS_MAIN;
      });

      // 监听摄像头的开启与关闭
      store.watch('presenter.videoOn', (val) => {
        if (val) {
        // 老师开启摄像头
          this.isCamera = true;
        } else {
        // 老师关闭摄像头
          this.isCamera = false;
        }
      }, true);

      store.watch('presenter.cameraCover', (v) => {
        if (v) {
          // 设置过/设置背景图
          this.isCameraImg = true;
        } else {
          // 未设置
          this.isCameraImg = false;
        }
      }, true);

      eventEmitter
        .on(
          eventEmitter.VIEW_RENDER_TRIGGER + this.namespace,
          () => {
          // 本事件触发表示直播服务已准备就绪，开始创建组件
            this.loaded = true;
          },
        )
        .on(
          eventEmitter.CLASSROOM_CONNECT_FAIL + this.namespace,
          () => {
            // 连接教室失败
            // eslint-disable-next-line no-alert
            alert('连接教室失败，请刷新重试');
          },
        )
        .on(
          eventEmitter.CLASSROOM_CONNECT_SUCCESS + this.namespace,
          () => {
            // 连接教室成功
            this.playing = false;
            this.liveStatus = store.get('class.started') ? 1 : 0; // 是否开始直播  0 未开始 1 已开始
          },
        )
        .on( // 上课
          eventEmitter.CLASS_START + this.namespace,
          () => {
            this.playing = false;
            this.liveStatus = 1;
          },
        )
        .on( // 下课
          eventEmitter.CLASS_END + this.namespace,
          () => {
            this.playing = false;
            this.liveStatus = 2; // 直播已结束
            this.stopLive();
          },
        )
        .on(
        // 视频开始播放事件
          eventEmitter.HTML_VIDEO_PLAY + this.namespace,
          () => {
            this.playing = true;
            this.liveStatus = 1;
            this.loading = false;
            this.controlShow = true; // 显示控制条

            this.startLive();
          },
        )
        .on(
        // 视频加载超时事件
          eventEmitter.HTML_VIDEO_LOAD_TIMEOUT + this.namespace,
          () => {
            this.playing = false;
            // eslint-disable-next-line no-alert
            alert('视频加载超时，请刷新重试');
          },
        )
        .on(
        // 视频加载失败事件
          eventEmitter.HTML_VIDEO_LOAD_FAIL + this.namespace,
          () => {
            this.playing = false;
            // eslint-disable-next-line no-alert
            alert('视频加载失败，请刷新重试');
          },
        )
        .on(
          eventEmitter.COMMAND_RECEIVE + this.namespace,
          (event, data) => {
            if (
              data.command
              && data.command.command_type === 'logout'
              && data.toId === store.get('user.id')
            ) {
              this.$toast('您被踢出直播间');
              setTimeout(() => {
                this.$router.back();
              }, 2000);
            }
          },
        )
        .on(
          eventEmitter.ROOM_SERVER_LOGIN_KICKED_OUT + this.namespace,
          () => {
            this.$toast('您已被禁止进入教室');
            setTimeout(() => {
              this.$router.back();
            }, 2000);
          },
        )
        .on(
          eventEmitter.LOGIN_CONFLICT + this.namespace,
          () => {
            // eslint-disable-next-line no-alert
            this.$toast('您已在另一设备进入直播间，请重新进入。');
            setTimeout(() => {
              this.$router.back();
            }, 2000);
          },
        );
    },
    // 点击播放
    clickPlayer() {
      this.loading = true;
      this.$refs.player.playLive();
    },
    touchstartHandle(refName, e) {
      if (this.isFull) return;
      const element = e.targetTouches[0];
      // 记录点击的坐标
      this.coordinate.client = {
        x: element.clientX,
        y: element.clientY,
      };
      // 记录需要移动的元素坐标
      this.coordinate.elePosition.left = this.$refs[refName].offsetLeft;
      this.coordinate.elePosition.top = this.$refs[refName].offsetTop;
    },
    touchmoveHandle(refName, e) {
      /* eslint-disable */
      if (this.isFull) return;
      const element = e.targetTouches[0];
      // 根据初始 client 位置计算移动距离(元素移动位置=元素初始位置+光标移动后的位置-光标点击时的初始位置)
      let x = this.coordinate.elePosition.left + (element.clientX - this.coordinate.client.x);
      let y = this.coordinate.elePosition.top + (element.clientY - this.coordinate.client.y);
      // 限制可移动距离，不超出可视区域
      x = x <= 0 ? 0 : x >= innerWidth - this.$refs[refName].offsetWidth ? innerWidth - this.$refs[refName].offsetWidth : x;
      y = y <= 0 ? 0 : y >= innerHeight - this.$refs[refName].offsetHeight ? innerHeight - this.$refs[refName].offsetHeight : y;
      // 移动当前元素
      this.$refs[refName].style.left = `${x}px`;
      this.$refs[refName].style.top = `${y}px`;
      e.preventDefault(); // 阻止屏幕滚动的默认行为
    },
     // 根据直播间id查询推荐的课程id  res?.data?.productList?.split(',');
    async getCourseIds() {
      const res = await reqliveDetails(Number(this.liveId));
      if (res?.code === 0) {
        this.RecommendCourse = res?.data;
      }
    },
    // 未购买跳转到详情页
    jumpCourseDetail() {
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: this.courseId,
        },
      });
    },
    onLineStatus() { //当前网络状态
      this.onLineTimer = setInterval(() => {
        if (navigator.onLine) {
          this.onLine = true;
        } else {
          this.playing = false;
          this.onLine = false;
        }
      },1000)
    },
    operation(value) {
      switch (value) {
        case 'changFull':
          this.isFull = !this.isFull;
          break
        case 'onlyPlayer':
          this.onlyPlayer = !this.onlyPlayer;
          break
        case 'hotRecommend':
          this.hotRecommendShow = true;
          break
        case 'closeControl':
          clearTimeout(this.setTimer)
          this.controlShow = false;
          break;
      }
    },
    fullScreen () { //全屏
      this.$nextTick(() => {
        const winH = window.innerHeight;
        const winW = window.innerWidth;
        const ele = document.getElementById('liveBJY')
        ele.style.width = `${winH}px`;
        ele.style.height = `${winW}px`;
        ele.style.transform = `rotate(90deg) translateX(-${winW}px)`;
        ele.style.transformOrigin = 'bottom left';
      });
  },
    exitFullScreen () { //退出全屏
      this.$nextTick(() => {
        const winW = window.innerWidth;
        const winH = window.innerHeight;
        const ele = document.getElementById('liveBJY')
        ele.style.width = `${winW}px`;
        ele.style.height = `${winH}px`;
        ele.style.transform = 'rotate(0)';
        ele.style.transformOrigin = 'bottom left';
      });
    },
    isTeacherShow() {  //教师姓名是否显示
      return this.isFull && (!this.playing || (this.templateType === 3 || (!this.isCamera && !this.isCameraImg)))
    },
    // 上传学习进度
    async sendUploadStudyProgressFun(isDrag) {
      if(!this.firstReport && isDrag === 1){
        return;
      }
      const nowTime = moment();
      if(isDrag === 1) {
        this.getliveStudyTime()
        this.reportTime = 0;
      } else if (isDrag === 0) {
        this.reportTime = 120;
      } else if (isDrag === 3) {
        this.reportTime = nowTime.diff(this.lastReportTime, 'seconds');
      }
      clearInterval(this.uploadTimer);
      this.uploadTimer = null;
      this.lastReportTime = nowTime;
      if(isDrag !== 3){
        // isDrag === 3 上报结束的情况下不重启定时器
        this.uploadTimer = setInterval(() => {
          this.sendUploadStudyProgressFun(0);
        }, 300000);
      }

      let { chapterId, liveId, buyRecord, courseId,reportTime,studyTime } = this;
      let { id } = this.userInfo;
      let data = {
        userId: id,
         productId: courseId,
          productSkuId: this.buyInfo.skuId,
          userProductId: this.buyInfo.id,
          curriculumId: this.buyInfo.productCurriculumId,
          chapterId,
          chapterName: this.$route.query.liveName,
          sourceType: 2,
          position: 0,
          reportTime,
          isDrag,
          source: 5,
          ua: window.navigator.userAgent,
          updateTime: this.$root.getLocalTime(),
          learnProgress:0,
      };
      const res = await sendUploadStudyProgress(data);
      if (res.code === 0) {
        // console.log("学习进度保存成功");
        this.firstReport = false;
      } else {
        clearInterval(this.uploadTimer);
        // console.log(res.msg + "-code非0停止上传学习进度");
      }
    },
    getliveStudyTime() {
      clearInterval(this.liveStudyTimer)
      this.liveStudyTimer = setInterval(() => {
        this.studyTime += 1;
      },1000)
    },
    startLive() {
      this.isLiveStart = true;
      this.studyStartTime = moment();
      this.studyTime = 0;
      this.lastReportTime = 0;
      this.reportTime = 0;
      this.firstReport = true;
      this.sendUploadStudyProgressFun(1); // 上报
    },
    stopLive(){  //结束直播
      if (!this.isLiveStart) {
        return;
      }
      if (this.lastReportTime === 0 || this.studyStartTime === 0) {
        return;
      }
      clearInterval(this.uploadTimer);
      clearInterval(this.liveStudyTimer)
      this.uploadTimer = null;
      this.liveStudyTimer = null;
      const nowTime = moment();
      this.reportTime = nowTime.diff(this.lastReportTime, 'seconds');
      this.sendUploadStudyProgressFun(3);
      this.isLiveStart = false;
    },
    destroyLiveRoom() {
      setTimeout(() => {
        // 如果直播间集成到单页面应用中，需要销毁直播间、解绑外层监听的事件、销毁通过 create 方式创建的组件（如 BJY.Whiteboard.create(...), 通过组件实例的 destroy 方法销毁）
        eventEmitter.off(this.namespace)
        BJY.dispose(BJY.config.BJY_DISPOSE_TYPE_OUT_ROOM)
      },100)
      clearInterval(this.onLineTimer)
      this.stopLive()
    }
  },
  mounted() {
    this.isLiveStart = false;
    this.onLineStatus()
  },
  beforeDestroy() {
    this.destroyLiveRoom()
  },
};
</script>
<style lang="scss">
  #liveBJY {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    background: #f9f9f9;
    .video-wrap{
      position: relative;
      width: 100%;
      height: calc(100vw * 0.5625);
    }
    .not-play-status {
        position: absolute;
        z-index: 2;
        width: 100%;
        height: calc(100vw * 0.5625);
        background: #000;
        div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          color: #fff;
          font-size: 32px;
          img {
            margin-bottom: 20px;
          }
        }
      }
    .other-video-wrap {
      position: absolute;
      top: calc(100vw * 0.91);
      right: 0;
      z-index: 3;
      width: 40vw;
      height: 22vw;
      font-size: 8px;
      background: #ccc;
      .bjy-player-play {
        width: 100%;
        height: 100%;
        .bjy-player-play-btn {
          width: 70px;
          height: 70px;
          margin-top: 20px;
          background-size: 100% 100%;
        }
      }
      &.noAdvertisement {
        top: calc(100vw * 0.69);;
      }
    }
    .media-panel {
      position: relative;
      flex-grow: 1;
      width: 100%;
      overflow: hidden;
    }
     &.fullscreen {
       overflow: hidden;
      .video-wrap {
        position: absolute;
        left: 0;
        width: 75%;
        height: 100vw;
        &.fullVideoWrap {
          width: 100vh;
        }
      }
      .fullOtherVideo {
        position: absolute;
        top: 0 !important;
        right: 0 !important;
        left: auto !important;
        width: 25%;
        height: 22%;
      }
      .media-panel {
        position: absolute;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 25%;
        height: 100vw;
        &.media-panel-teacher {
          top: 10%;
          height: 90%;
        }
        &.media-panel-player {
          top:22%;
          height: 78%;
        }
      }
    }
  }
</style>
